import { DecodedJwtPayload } from './types';

function base64UrlDecode(segment: string): string {
  segment = segment.replace(/-/g, '+').replace(/_/g, '/');
  const pad = segment.length % 4;
  if (pad) segment += '='.repeat(4 - pad);
  try {
    if (typeof atob === 'function') {
      return atob(segment);
    }
  } catch {}
  // Node.js fallback
  return Buffer.from(segment, 'base64').toString('utf8');
}

export function decodeJwt(token: string | null | undefined): DecodedJwtPayload | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payloadStr = base64UrlDecode(parts[1]);
    return JSON.parse(payloadStr);
  } catch {
    return null;
  }
}

export function willExpireSoon(token: string | null | undefined, thresholdSeconds = 60): boolean {
  const payload = decodeJwt(token);
  if (!payload?.exp) return false;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp - now < thresholdSeconds;
}
